// extracted by mini-css-extract-plugin
export default {"btnWide":"button_btnWide__eSBWd"};